/* Home V3 (templates/index.liquid). Spec: Strategy/2026-10/home-v3/Spec-2026-10-03.md.
   1. Hero finder: three selects driven by the Garage vocabulary; submit saves
      with BGE.Garage.add and goes to BGE.browseUrl, as the Garage drawer does
      on the home page. No fitment or garage logic lives here.
   2. Known machine: the plate names the active machine, links to its parts,
      and switches between saved machines. The inline script in the section
      already showed it before first paint; this keeps it in step with the Garage.
   3. Popular machines: the four class panels become tabs; the saved machine's
      class opens first. The "Yours" mark itself is bge-known-fit.js.
   GA4 events through a nil-safe gtag: home_finder_submit, home_finder_known_click,
   home_tab. Every button is also counted by the delegated bgv2_cta event. */
(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* ignore */ }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function opt(value, label, selected) {
    return '<option value="' + esc(value) + '"' + (selected ? ' selected' : '') + '>' + esc(label) + '</option>';
  }
  // bge-garage.js and bge-known-fit.js load after this file (layout order), and this file runs as soon as the page is
  // parsed, so the Garage is not there yet. A 10 s poll gave up on a slow phone (the Garage ran at DOMContentLoaded,
  // about 26 s on Slow 4G) and the finder never filled (FL5-13). Try now, then at DOMContentLoaded, when every
  // deferred script has run.
  function whenGarage(cb) {
    var done = false;
    function check() {
      if (done || !(window.BGE && window.BGE.Garage)) return;
      done = true;
      cb(window.BGE);
    }
    check();
    if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', check);
  }
  function modelName(v) { return v.model || v.make; }
  function machineName(B, v) { return B.formatVehicle ? B.formatVehicle(v) : [v.year, v.make, v.model].filter(Boolean).join(' '); }
  function partsUrl(B, v) { return (B.modelUrl && B.modelUrl(v)) || B.browseUrl(v); }

  // ---------------------------------------------------------------- 1. Finder
  function initFinder(B, root) {
    var form = qs('[data-bgv3h-form]', root);
    var year = qs('[data-bgv3h-year]', root);
    var make = qs('[data-bgv3h-make]', root);
    var model = qs('[data-bgv3h-model]', root);
    var err = qs('[data-bgv3h-err]', root);
    var hint = qs('[data-bgv3h-hint]', root);
    var submit = qs('[data-bgv3h-submit]', root);
    if (!form || !year || !make || !model) return;
    // Every save needs a model (Ricky: "require"): the button waits for it and the hint says so.
    function missing() {
      return !year.value ? 'Pick your year, make and model' : !make.value ? 'Pick your make and model' :
        !model.value ? ((hint && hint.getAttribute('data-model')) || 'Pick your model') : '';
    }
    function sync() {
      var m = missing();
      if (submit) submit.disabled = !!m;
      if (hint) { hint.textContent = m; hint.hidden = !m; }
      if (!m && err) err.textContent = '';
    }

    function entries(vocab, mk) {
      return ((vocab.models_by_make && vocab.models_by_make[mk]) || []).map(function (m) {
        return typeof m === 'string' ? { name: m, year_start: 1985, year_end: 2030 } : m;
      });
    }
    function inYear(m, y) { return !y || (y >= m.year_start && y <= m.year_end); }

    function fill(vocab) {
      year.innerHTML = opt('', 'Year') + vocab.years.slice().sort(function (a, b) { return b - a; }).map(function (y) { return opt(y, y); }).join('');
      year.addEventListener('change', function () {
        var y = parseInt(year.value, 10);
        var keep = make.value;
        var makes = vocab.makes.filter(function (mk) { return entries(vocab, mk).some(function (m) { return inYear(m, y); }); });
        make.innerHTML = opt('', 'Make') + makes.map(function (mk) { return opt(mk, mk, mk === keep); }).join('');
        make.disabled = !y;
        make.dispatchEvent(new Event('change'));
      });
      make.addEventListener('change', function () {
        var y = parseInt(year.value, 10);
        var keep = model.value;
        var models = make.value ? entries(vocab, make.value).filter(function (m) { return inYear(m, y); }) : [];
        model.innerHTML = opt('', 'Model') + models.map(function (m) { return opt(m.name, m.name, m.name === keep); }).join('');
        model.disabled = !make.value;
        if (err) err.textContent = '';
        sync();
      });
      model.addEventListener('change', sync);
      sync();
    }

    // The vocabulary loads after the Garage boots; fill when it lands, however late (no 10 s cut-off, FL5-13).
    var filled = false;
    function fillOnce() { if (!filled && B.Garage.vocab) { filled = true; fill(B.Garage.vocab); } }
    fillOnce();
    if (!filled) B.Garage.onChange(function (ev) { if (ev === 'vocab_loaded') fillOnce(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!year.value || !make.value || !model.value) {
        if (err) err.textContent = missing();
        (year.value ? (make.value ? model : make) : year).focus();
        return;
      }
      var v = B.Garage.add(parseInt(year.value, 10), make.value, model.value);
      track('home_finder_submit', { year: year.value, make: make.value, model: model.value });
      if (!v) { if (B.openGarage) B.openGarage(); return; } // Garage full: let the rider choose what to drop.
      window.location.href = B.browseUrl(v, { strict: true });
    });
  }

  // ---------------------------------------------------------- 2. Known plate
  function initKnown(B, root) {
    var form = qs('[data-bgv3h-form]', root);
    var known = qs('[data-bgv3h-known]', root);
    var nameEl = qs('[data-bgv3h-known-name]', root);
    var link = qs('[data-bgv3h-known-link]', root);
    var sw = qs('[data-bgv3h-switch]', root);
    if (!known || !form || !nameEl || !link) return;
    var label = root.getAttribute('data-shop') || 'Shop parts for my {model}';
    var switchLabel = sw ? (sw.getAttribute('aria-label') || '') : '';

    var pick = qs('[data-bgv3h-pick]', root);
    function render() {
      var list = B.Garage.list();
      var v = B.Garage.active() || list[0];
      var old = !v && B.Garage.needsModel ? B.Garage.needsModel()[0] : null;
      if (pick) { pick.hidden = !old; pick.innerHTML = old && B.pickModelHtml ? B.pickModelHtml(old, 'bgv2-btn bgv2-btn--primary bgv2-btn--lg', 'Pick your model') : ''; }
      link.hidden = !!old;
      known.classList.toggle('bgv3h-known--legacy', !!old); // no tick: nothing is confirmed yet
      if (old) {
        // Saved before a model was required: name it, no parts link, one tap to finish it.
        form.hidden = true;
        known.hidden = false;
        root.setAttribute('data-bgv3h-state', 'known');
        nameEl.textContent = machineName(B, old);
        if (sw) { sw.hidden = true; sw.innerHTML = ''; }
        return;
      }
      if (!v) {
        known.hidden = true;
        form.hidden = false;
        root.removeAttribute('data-bgv3h-state');
        return;
      }
      form.hidden = true;
      known.hidden = false;
      root.setAttribute('data-bgv3h-state', 'known');
      nameEl.textContent = machineName(B, v);
      link.textContent = label.replace('{model}', modelName(v));
      link.setAttribute('href', partsUrl(B, v));
      if (sw) {
        var others = list.filter(function (x) { return x.id !== v.id; });
        sw.hidden = !others.length;
        sw.innerHTML = others.length ? '<li class="bgv3h-eyebrow" aria-hidden="true">' + esc(switchLabel) + '</li>' + others.map(function (x) {
          return '<li><button type="button" class="bgv2-btn bgv2-btn--secondary bgv2-btn--sm" data-bgv3h-set="' + esc(x.id) + '">' + esc(machineName(B, x)) + '</button></li>';
        }).join('') : '';
      }
    }
    render();
    B.Garage.onChange(render);

    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-bgv3h-set]');
      if (b) { B.Garage.setActive(b.getAttribute('data-bgv3h-set')); return; }
      if (e.target.closest && e.target.closest('[data-bgv3h-known-link]')) {
        var v = B.Garage.active();
        track('home_finder_known_click', { machine: v ? machineName(B, v) : '' });
      }
    });
  }

  // ------------------------------------------------------- 3. Machine tabs
  // The class of a saved machine (ATV, UTV, Dirt Bike, Dual-Sport) when no tile is that machine: the class tag
  // of a part that fits it, from one predictive search kept for the session (F5-21).
  var CLASS_TAGS = ['Dual-Sport', 'Dirt Bike', 'UTV', 'ATV', 'Street'];
  function machineClass(B, v) {
    if (!v || !v.model || !B.parseTags || !B.checkFitment) return Promise.resolve('');
    var key = 'bgv3h_class:' + (v.make + '|' + v.model).toLowerCase();
    try { var c = window.sessionStorage.getItem(key); if (c !== null) return Promise.resolve(c); } catch (e) { /* private mode */ }
    var url = '/search/suggest.json?q=' + encodeURIComponent(v.make + ' ' + v.model) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,tag';
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
      var cls = '';
      ps.some(function (p) {
        var tags = p.tags || [];
        var st = B.checkFitment(B.parseTags(tags.join('|')), v, p.type);
        if (st !== 'fits' && st !== 'wrong_year') return false;
        cls = CLASS_TAGS.filter(function (t) { return tags.indexOf(t) >= 0; })[0] || '';
        return !!cls;
      });
      try { window.sessionStorage.setItem(key, cls); } catch (e) { /* private mode */ }
      return cls;
    }).catch(function () { return ''; });
  }
  function initTabs() {
    var wrap = qs('[data-bgv3h-machines]');
    var bar = wrap && qs('[data-bgv3h-tabs]', wrap);
    var panels = wrap ? qsa('[data-bgv3h-panel]', wrap) : [];
    if (!bar || panels.length < 2) return;

    // The tabs come rendered by bgv3-home-vehicles.liquid (RV-02); build them only if an older markup has none.
    var ready = qsa('[role="tab"]', bar);
    var tabs = ready.length === panels.length ? ready : panels.map(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bgv3h-tab';
      b.id = p.id + '-tab';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-controls', p.id);
      b.textContent = p.getAttribute('data-label') || ('Tab ' + (i + 1));
      p.setAttribute('role', 'tabpanel');
      p.setAttribute('aria-labelledby', b.id);
      p.setAttribute('tabindex', '0');
      bar.appendChild(b);
      return b;
    });

    function select(i, focus, user) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
      if (user) track('home_tab', { tab: panels[i].getAttribute('data-class') });
    }
    var picked = false, run = 0;
    bar.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[role="tab"]');
      if (t) { picked = true; select(tabs.indexOf(t), false, true); }
    });
    bar.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var n = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (n === undefined) return;
      e.preventDefault();
      picked = true;
      select((n + tabs.length) % tabs.length, true, true);
    });
    wrap.classList.add('is-tabbed');

    // Open the class of the rider's active machine when one of its tiles is that machine.
    function start() {
      var B = window.BGE;
      var v = B && B.Garage && B.Garage.active();
      var want = v ? [B.modelUrl && B.modelUrl(v), B.browseUrl(v)].filter(Boolean) : [];
      var at = 0, found = false, token = ++run;
      if (want.length) {
        found = panels.some(function (p, i) {
          var hit = qsa('a.bgv2-models__tile', p).some(function (a) { return want.indexOf(a.pathname.replace(/\/$/, '')) >= 0; });
          if (hit) at = i;
          return hit;
        });
      }
      select(at, false, false);
      if (v && !found) {
        // Not a tile (a 2019 Pioneer 700 opened on ATV): open its class's tab, unless the rider has picked one.
        machineClass(B, v).then(function (cls) {
          if (token !== run || picked || !cls) return;
          var j = -1;
          panels.forEach(function (p, i) { if (p.getAttribute('data-class') === cls) j = i; });
          if (j > 0) select(j, false, false);
        });
      }
    }
    start();
    return start;
  }

  function boot() {
    var hero = qs('[data-bgv3h-finder]');
    var tabStart = initTabs();
    whenGarage(function (B) {
      if (hero) { initFinder(B, hero); initKnown(B, hero); }
      if (tabStart) { tabStart(); B.Garage.onChange(tabStart); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
